export enum SummaryType {
	DAY = 'day',
	WEEK = 'week',
	MONTH = 'month',
	CUSTOM = 'custom'
}
